export const MAX_TRAITS = 4
export const TABLE_ROW_CLASS_NAMES = "bg-transparent"
